'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PERSONAL = exports.PERSONAL = {
  'PHOTO_ID': 'Photo ID',
  'TAX_RETURN': 'Tax Return',
  'SIGNATURE_PAGE': 'Signature Page',
  'W-2': 'W-2',
  'INTEREST_INCOME': 'Interest Income',
  'ALIMONY': 'Alimony',
  'RENTAL_PROPERTY': 'Rental Property',
  'SOCIAL_SECURITY_BENEFITS': 'Social Security Benefits',
  'UNEMPLOYMENT': 'Unemployment',
  'INVESTMENTS': 'Investments',
  'MISC_INCOME': 'Misc Income',
  'HEALTH_CARE': 'Health Care',
  'HOME_MORTGAGE_INTEREST': 'Home Mortgage Interest',
  'MEDICAL': 'Medical',
  'STUDENT_LOANS': 'Student Loans',
  'FOREIGN': 'Foreign',
  'OTHER': 'Other'
};

var BUSINESS = exports.BUSINESS = {
  'PHOTO_ID': 'Photo ID',
  'TAX_RETURN': 'Tax Return',
  'SIGNATURE_PAGE': 'Signature Page',
  'TRIAL_BALANCE': 'Trial Balance',
  'PROFIT_AND_LOSS_STMT': 'Profit and Loss Stmt',
  'REVENUE': 'Revenue',
  'EXPENSES': 'Expenses',
  'EQUITY': 'Equity',
  'BANK_STATEMENTS': 'Bank Statements',
  'CREDIT_CARD_STATEMENTS': 'Credit Card Statements',
  'INVENTORY': 'Inventory',
  'FIXED_ASSETS': 'Fixed Assets',
  'PAYROLL': 'Payroll',
  'FOREIGN': 'Foreign',
  'OTHER': 'Other'
};
//# sourceMappingURL=DocumentTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/misc/DocumentTypes.js
// module id = 631
// module chunks = 0